import React from "react";
import Whats from "./Whats";
import { Fade } from "react-awesome-reveal";
import "../styles/Header.scss";
import logo from "../images/logoHF.png"; // usa tu logo pixbae aquí

const Header = () => {
  return (
    <header className="headerPixbae">
      <nav className="navbar navbar-expand-lg navBarCustom" data-bs-theme="dark">
        <div className="container-fluid">
          <a className="navbar-brand brandPixbae" href="#inicio" aria-label="Ir al inicio">
            <img className="imgLogo" src={logo} alt="Logo Pixbae Banquetes" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Abrir menú"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 navLinksPixbae">
              <li className="nav-item">
                <a className="nav-link" aria-current="page" href="#inicio">
                  Inicio
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#nosotros">
                  Nosotros
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#allServices">
                  Paquetes
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#galeria">
                  Galería
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#formulario">
                  Contacto
                </a>
              </li>
            </ul>

            <div className="d-flex ctaWrap">
              <Fade cascade direction="left">
                <Whats
                  classStyle="btn btnContactanos"
                  message="Hola, me gustaría cotizar un banquete. ¿Me compartes paquetes y disponibilidad?"
                  text="Cotizar por WhatsApp"
                  phoneNumber="523345851702"
                />
              </Fade>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
